import { render, staticRenderFns } from "./Disbursements.vue?vue&type=template&id=72100051&"
import script from "./Disbursements.vue?vue&type=script&lang=js&"
export * from "./Disbursements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QSpace,QTable,QTd,QToggle,QSelect,QInput,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QSpace,QTable,QTd,QToggle,QSelect,QInput,QIcon})
